import { cn } from '@/lib/cn';

interface DotIndicatorProps {
  total: number;
  current: number; // 0-based step index (0 = first step)
}

/**
 * Onboarding progress dots. The group exposes "Step N of M" to screen
 * readers (there is no visible step counter — the dots ARE the counter).
 */
export function DotIndicator({ total, current }: DotIndicatorProps) {
  return (
    <div
      role="img"
      aria-label={`Step ${current + 1} of ${total}`}
      className="flex items-center justify-center gap-[5px]"
    >
      {Array.from({ length: total }, (_, i) => (
        <div
          key={i}
          aria-hidden
          className={cn(
            'h-[7px] w-[7px] rounded-full transition-colors duration-popover',
            i < current && 'bg-brand-ink',
            i === current && 'bg-brand',
            i > current && 'bg-line-2',
          )}
        />
      ))}
    </div>
  );
}
